module.exports = __webpack_public_path__ + "img/联系我们_电话.57de7759.svg";